module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      data = _ref.data;

  if (!data) throw new TypeError('data is required');
  if (data === '<li>Invalid login or password.</li>') throw new Error('Invalid Skyward credentials');
  var tokens = data.slice(4, -5).split('^');
  if (tokens.length < 15) throw new Error('Malformed auth data');
  return {
    dwd: tokens[0],
    wfaacl: tokens[3],
    encses: tokens[14],
    sessionId: "".concat(tokens[1], "%15").concat(tokens[2])
  };
};